import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from '@material-ui/core/styles';
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Translator from "Languages/Utility/Translator";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";
import { useSetState } from "Helpers/Hooks";
import { read } from "Helpers/LocalStorage";
import StatusHandler from "Helpers/StatusHandler";
import DrawerService from "Services/http/endpoints/design/DrawerService";
import { useDispatch, useSelector } from "react-redux";
import { UNIT_INFO } from "Stores/actionTypes";
import {DialogActions} from "@material-ui/core";
import MuiButton from "Components/MuiButton/MuiButton";

function SelectTemplateDialog({
  handleDialog,
  openDialog,
  data,
  sendConvertData,
}) {
  const { direction } = useTheme();
  const { unitInfo } = useSelector((state) => ({
    unitInfo: state.design.unitInfo,
  }));
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [controls, setControls] = useSetState({
    template: {
      type: "select",
      selectItems: [],
      value: "",
    },
  });

  const onFinish = async () => {
    const { template } = controls;
    try {
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        IdTemplate: template.value.value,
        IdTemplateRail: unitInfo.Id_template,
      };
      const response = await DrawerService.GetInfoTemplateLolaeeForStyle(
        params
      );
      let err = StatusHandler(response);
      if (!err.isFail) {
        const newValue = response.data.Value;
        const convertData = {
          Group_base: data.group_base,
          Id_template_bazsho: template.value.value,
          Id_frame_bazsho: newValue.IdFrame,
          Id_mulion_bazsho: newValue.IdMulion,
          Id_sash_bazsho: newValue.IdSash,
          Id_sash_door_bazsho: newValue.IdSashDoor,
          Id_averhang_bazsho: newValue.IdOverhung,
          Id_zehvar_bazsho: newValue.IdZehvar,
          Id_brand_bazsho: newValue.IdBrandFitting,
          Size_frame_bazsho: newValue.SizeFrame,
          Size_sash_bazsho: newValue.SizeSash,
          Size_sash_door_bazsho: newValue.SizeSashDoor,
          Size_mulion_bazsho: newValue.SizeMulion,
        };
        const updateUnitInfo = {
          ...unitInfo,
          ...convertData,
          Sys_tak_joft: newValue.Sys_tak_joft,
        };
        dispatch({
          type: UNIT_INFO,
          unitInfo: updateUnitInfo,
        });
        sendConvertData(convertData, updateUnitInfo);
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
  };

  const onEnter = async () => {
    try {
      setLoading(true);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Struct: unitInfo.Type_struct,
        IdFrame: data.baseId,
      };
      const response = await DrawerService.GetTemplateLolaeeForStyle(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const list = response.data.Value;
        const update = list.map((item) => {
          return {
            ...item,
            label: item.Name,
            value: item.Id,
          };
        });
        setControls({ template: { value: update[0] } });
        setControls({ template: { selectItems: update } });
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
  };

  return (
    <Dialog
      dir={direction}
      open={openDialog}
      onClose={handleDialog}
      onEnter={onEnter}
      fullWidth
      maxWidth="sm"
    >
      <div className="dialogHeader">
        <p>انتخاب الگو بازشو</p>
      </div>
      <DialogContent style={{ overflow: "visible" }}>
        {!loading ? (
          <Grid container className="p-1">
            <Grid item xs={12} className="px-2">
              <MuiAutoComplete
                autoSelect={true}
                options={controls.template.selectItems}
                label={<Translator id={"template"} />}
                value={controls.template.value}
                id={"template"}
                onChange={autoCompleteHandler}
              />
            </Grid>
          </Grid>
        ) : (
          <MuiSkeleton xs={6} number={2} />
        )}
      </DialogContent>
      <DialogActions>
        <MuiButton
            color="primary"
            onClick={onFinish}
            title={<Translator id="button_save" />}
        />
        <MuiButton
            onClick={handleDialog}
            title={<Translator id="enseraf" />}
        />
      </DialogActions>
    </Dialog>
  );
}

export default SelectTemplateDialog;
